module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('datatable', {
    attrs: {
      "tablename": "datatable-carehome-patient-list",
      "columns": _vm.columns,
      "source": _vm.getRecords,
      "datachanged": _vm.carehomeid
    },
    on: {
      "selected": _vm.recordSelected
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7634042b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7634042b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/carehome-patients/list/carehome-patient-list.scp.html
// module id = 497
// module chunks = 0